export const EmailConfirmedStatus = {
  Confirmed: 200,
  AlreadyConfirmed210: 210,
  AlreadyConfirmed409: 409,
  TokenExpired: 220,
  Error: 400,
  getKey
}
// get the enum key by value
function getKey(enumValue) {
  return Object.keys(EmailConfirmedStatus).find(
    key => EmailConfirmedStatus[key] === enumValue
  )
}
